import React, { useState } from 'react';
import { Button, Space, Tooltip, Dropdown, Menu, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { EditOutlined, MoreOutlined, ReloadOutlined, FlagOutlined } from '@ant-design/icons';
import ContactEditModal from '../../Shared/ContactEditModal/ContactEditModal';

const TestHeaderActions = ({ screens, conversation, onContactUpdated, onNewTest }) => {
    const { t } = useTranslation();
    const [editModalVisible, setEditModalVisible] = useState(false);

    const handleReport = () => {
        message.success(t('report_submitted_successfully'));
    };

    const mobileMenu = (
        <Menu>
            <Menu.Item key="edit-contact" icon={<EditOutlined />} onClick={() => setEditModalVisible(true)}>
                {t('edit_contact')}
            </Menu.Item>
            <Menu.Item key="new-test" icon={<ReloadOutlined />} onClick={onNewTest}>
                {t('new_test')}
            </Menu.Item>
            <Menu.Item key="report-issue" icon={<FlagOutlined />} onClick={handleReport}>
                {t('report_issue')}
            </Menu.Item>
        </Menu>
    );

    return (
        <>
            {screens?.xs ? (
                <Dropdown overlay={mobileMenu} trigger={["click"]}>
                    <Button icon={<MoreOutlined />} shape="circle" />
                </Dropdown>
            ) : (
                <Space size={4} wrap={false} style={{ flexShrink: 1, minWidth: 0 }}>
                    <Tooltip title={t('edit_contact_information')}>
                        <Button
                            icon={<EditOutlined />}
                            onClick={() => setEditModalVisible(true)}
                        />
                    </Tooltip>
                    <Tooltip title={t('new_test')}>
                        <Button
                            icon={<ReloadOutlined />}
                            onClick={onNewTest}
                        />
                    </Tooltip>
                    <Tooltip title={t('report_issue')}>
                        <Button
                            icon={<FlagOutlined />}
                            onClick={handleReport}
                        />
                    </Tooltip>
                </Space>
            )}

            <ContactEditModal
                visible={editModalVisible}
                onCancel={() => setEditModalVisible(false)}
                contact={conversation?.contact}
                onSuccess={() => {
                    if (typeof onContactUpdated === 'function') {
                        try { onContactUpdated(); } catch (e) { }
                    }
                }}
            />
        </>
    );
};

export default TestHeaderActions;


